export const supportsTouch = (() =>
  !!('ontouchstart' in window || navigator.msMaxTouchPoints))()
